import React, { useState } from 'react';
import { useLanguage } from '../../../contexts/LanguageContext';
import api from '../../../utils/api';
import Navbar from '../../Layout/Navbar';
import Footer from '../../Layout/Footer';
import './Contact.css';

const Contact = () => {
  const { t } = useLanguage();
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    subject: '',
    message: ''
  });
  const [message, setMessage] = useState('');

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage('');

    try {
      const response = await api.post('/contact', formData);
      setMessage(response.data.message || t('contact.messageSent', 'Thank you! Your message has been sent successfully.'));
      setFormData({
        name: '',
        email: '',
        phone: '',
        subject: '',
        message: ''
      });
    } catch (error) {
      const serverMsg = error.response?.data?.message;
      const hint = error.response?.data?.hint;
      const errDetail = error.response?.data?.error;
      const displayMsg = serverMsg || t('contact.messageError', 'Error sending message. Please try again or call us directly.');
      setMessage(hint ? `${displayMsg} ${hint}` : errDetail ? `${displayMsg} (${errDetail})` : displayMsg);
      console.error('Contact form error:', error.response?.data || error);
    }
  };

  return (
    <div className="contact-page">
      <Navbar />

      <section className="page-hero">
        <div className="container">
          <h1>{t('contact.title', 'Contact Us')}</h1>
          <p>{t('contact.subtitle', 'Get in touch with us today')}</p>
        </div>
      </section>

      <section className="contact-section">
        <div className="container">
          <div className="contact-grid">
            <div className="contact-info">
              <h2>{t('contact.getInTouch', 'Get in Touch')}</h2>
              <p>{t('contact.getInTouchDesc', "We're here to help! Reach out to us through any of the following methods.")}</p>

              <div className="contact-details">
                <div className="contact-item">
                  <div className="contact-icon">📞</div>
                  <div>
                    <h3>{t('contact.phone', 'Phone')}</h3>
                    <p>{t('footer.phonenr', 'Phonenr')}</p>
                    <p>{t('contact.phoneHours', 'phoneHours')}</p>
                  </div>
                </div>

                <div className="contact-item">
                  <div className="contact-icon">✉️</div>
                  <div>
                    <h3>{t('contact.email', 'Email')}</h3>
                    <p>{t('footer.emails', 'emails')}</p>
                    <p>{t('contact.emailResponse', 'We respond within 24 hours')}</p>
                  </div>
                </div>

                <div className="contact-item">
                  <div className="contact-icon">📍</div>
                  <div>
                    <h3>{t('contact.address', 'Address')}</h3>
                    <p>{t('contact.streetAddress', 'streetAddress')}</p>
                    <p>{t('contact.cityCountry', 'Copenhagen, Denmark')}</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="contact-form-container">
              <h2>{t('contact.sendMessage', 'Send us a Message')}</h2>
              <form onSubmit={handleSubmit} className="contact-form">
                <div className="form-group">
                  <label>{t('auth.fullName', 'Full Name')} *</label>
                  <input
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="form-row">
                  <div className="form-group">
                    <label>{t('auth.email', 'Email')} *</label>
                    <input
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      required
                    />
                  </div>

                  <div className="form-group">
                    <label>{t('auth.phone', 'Phone')}</label>
                    <input
                      type="tel"
                      name="phone"
                      value={formData.phone}
                      onChange={handleChange}
                    />
                  </div>
                </div>

                <div className="form-group">
                  <label>{t('contact.subject', 'Subject')} *</label>
                  <select
                    name="subject"
                    value={formData.subject}
                    onChange={handleChange}
                    required
                  >
                    <option value="">{t('contact.selectSubject', 'Select a subject...')}</option>
                    <option value="quote">{t('contact.requestQuote', 'Request a Quote')}</option>
                    <option value="service">{t('contact.serviceInquiry', 'Service Inquiry')}</option>
                    <option value="complaint">{t('contact.complaint', 'Complaint')}</option>
                    <option value="other">{t('contact.other', 'Other')}</option>
                  </select>
                </div>

                <div className="form-group">
                  <label>{t('contact.message', 'Message')} *</label>
                  <textarea
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    rows="6"
                    required
                  />
                </div>

                {message && (
                  <div className={`message ${message.includes('Error') ? 'error' : 'success'}`}>
                    {message}
                  </div>
                )}

                <button type="submit" className="btn btn-primary btn-block">{t('contact.sendMessageButton', 'Send Message')}</button>
              </form>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Contact;
